export const QUOTE = "quote"
export const QUOTES = "quotes" as const

export namespace QUOTE_STATUS {
    export const NEW = "new"
    export const DRAFT = "draft"
    export const CANCELLED = "cancelled"
}



// WEBPACK FOOTER //
// ./src/state/quote/Constants.ts